// const baseApi = '192.168.3.7:7000/api/v1'
// const baseApi = '192.168.3.232:8000/api/v1'
// const baseApi = '192.168.168.117:8000/api/v1'
// const baseApi = "localhost:8000/api/v1";
// const baseApi = "store.projmantech.com/api/v1";
const baseApi = "inventory.infotechitsolutionsbd.com/api/v1";
export default baseApi;
